// extracted by mini-css-extract-plugin
module.exports = {"form":"formStyle_form__1QSZ0","formGroup":"formStyle_formGroup__1b56F"};